import Operation from "../index.js";

export default {
    //downLoad
    urlToBase64(url, fn) {
        Operation.Http.post(`/urlToBase64?url=${url}`, null, fn)
    },
    //上传文件
    upload(file, fn) {
        Operation.Http.postImgFile(`/upload`, file, fn)
    },
    //删除文件
    deleteFile(url, fn) {
        Operation.Http.post(`/deleteFile?url=${url}`, null, fn)
    },
    //删除word 文件
    deleteCourseware(url, fun) {
        Operation.Http.post(`/deleteCourseware?url=${url}`, null, fun)
    },
    downLoad(url, fn) {
        Operation.Http.getFile(`/downLoad?url=${url}`, null, fn);
    },
}



// WEBPACK FOOTER //
// ./src/request/api/file.js